'use es6';

import Stylesheets from '../models/Stylesheets';
import { RECEIVED_STYLESHEETS, REQUESTED_STYLESHEETS_FAILED, REQUESTED_STYLESHEETS } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new Stylesheets(), action) => {
  switch (action.type) {
    case REQUESTED_STYLESHEETS:
      return state.set('status', RequestStatus.PENDING);
    case RECEIVED_STYLESHEETS:
      return action.payload.stylesheets;
    case REQUESTED_STYLESHEETS_FAILED:
      return state.set('status', RequestStatus.FAILED);
    default:
      return state;
  }
});